import { ChangeContext, Options } from "@angular-slider/ngx-slider";
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as dwv from 'dwv';
import FileSaver from 'file-saver';
import { NgxSelectOption } from 'ngx-select-ex';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from "../../../../../environments/environment"; 
import { RadiologyEhr, RadiologyEhrData } from "../../../../@core/interfaces/ehr/radiology-ehr";
import { Physician,PhysicianData } from "../../../../@core/interfaces/masters/physician-mst"; 
import { RadiologyCompareComponent } from '../radiology-compare/radiology-compare.component';
//UTC Time Convert(Thenmpzhi)
import { DateService } from "../service/date.service"; 
// gui overrides
import * as period from '../../../../data/period.json';


// get element
dwv.gui.getElement = dwv.gui.base.getElement;
dwv.gui.prompt = dwv.gui.base.prompt;

// Image decoders (for web workers)
dwv.image.decoderScripts = {
  jpeg2000: 'assets/dwv/decoders/pdfjs/decode-jpeg2000.js',
  'jpeg-lossless': 'assets/dwv/decoders/rii-mango/decode-jpegloss.js',
  'jpeg-baseline': 'assets/dwv/decoders/pdfjs/decode-jpegbaseline.js',
  rle: 'assets/dwv/decoders/dwv/decode-rle.js'
};

@Component({
  selector: 'ngx-radiology-ehr',
  templateUrl: './radiology.component.html',
  styleUrls: ['./radiology.component.scss']
})
export class RadiologyComponent implements OnInit {
  protected readonly unsubscribe$ = new Subject<void>();
  allowClear: any = true;
  multiple: boolean = false;
  value: number = 0;
  highValue: number = 60;
  options: Options = {
    floor: 0,
    ceil: 100
  };
  public tools = {
    Scroll: {},
    Filter: {
      options: ["Threshold", "Sharpen", "Sobel"],
      type: "instance",
      events: ["filter-run", "filter-undo"]
    },
    ZoomAndPan: {},
    WindowLevel: {},
    Draw: {
      options: ['Ruler', 'Roi', 'Ellipse', 'Arrow', 'FreeHand', 'Protractor', 'Rectangle'],
      type: 'factory',
      events: ['draw-create', 'draw-change', 'draw-move', 'draw-delete', 'dblclick']
    }
  };
  scrollIcon: boolean = true;
  @ViewChild("compareId", { static: true }) compareInst: RadiologyCompareComponent;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  public selectedTool = 'Scroll';
  public drawTool = 'Ruler';
  public filterTool = 'Threshold';
  private dwvApp: any;
  loadProgress: number = 0;
  dataLoaded: boolean = false;
  isSingleView: boolean = false;
  selectedArr: Array<any> = [];
  toolsList: String[] = ["Scroll", "Filter", "ZoomAndPan", "WindowLevel", "Draw"];
  drawoptionList: String[] = ['Ruler', 'Roi', 'Ellipse', 'Arrow', 'FreeHand', 'Protractor', 'Rect'];
  filterList: String[] = ["Threshold", "Sharpen", "Sobel"];
  dataRange: { min: number, max: number };
  regId: any;
  filesDet: any = [];
  dataSourceRadiologyGrid: any = [];
  curSingleDet: RadiologyEhr;
  notes = "";
  phy = null;
  notesView: boolean = false;
  info: boolean = false;
  editInfo: any;
  isCompareView: boolean = false;
  userName: string = "";
  btnDisable: boolean = false;
  isMetaTags: boolean = false;
  isEdit: boolean = false;
  isImg: boolean = true;
  infoForm: FormGroup;
  phyList: Physician[];
  loadPhyList: Physician[];
  placeholder: string = "Select";
  saveDataFlag: boolean = false;
  imgView: boolean = false;
  imgname: any;
  term: string;
  fullData: Array<any> = [];
  rangeDate: Date[];
  radiologyPrint: boolean = false;
  // Variables declared by Abirami P
  radiologyIndex: number;
  showTxt = "See More";
  last_index = 100;
  counter = 100;
  NotesValue: any;
  showHidden: boolean = false;
  duplicateNotesValues: any[];
  firstCount = 100;
  p: number = 1;
  deleteaddedRadiology: boolean = false;
  deleteId: any;
  openradTemplatePopUp: boolean = false;
  radDet: any;
  // Any type Declaration Confirmed with Anandh
  viewData: any;
  period: string;
  periodList: string[] = (period as any).default;
  betweenFlag: boolean;
  patientPortalFlag: boolean=false;
  link: string='';


  constructor(private dateService: DateService, private radiologySrvc: RadiologyEhrData, protected phySrvc: PhysicianData,
    private fb: FormBuilder, private route: ActivatedRoute, private datePipe: DatePipe) {
    this.route.params.subscribe(params => {
      this.regId = params['regId'];
    });
    this.infoForm = this.fb.group({
      info: this.fb.control(null),
      physician: this.fb.control(null),
      fileName: this.fb.control(null)

    });
  }

  viewSummary(x) {
    this.radDet = x;
    this.openradTemplatePopUp = true;
  }

  radTemplateCancel() {

    this.openradTemplatePopUp = false;
  }

  StartPatientData() {
    this.loadPhy();
    this.loadFileData();
    this.dwvApp = new dwv.App();
    var state = new dwv.State();
    // initialise app
    this.dwvApp.init({
      "containerDivId": "dwv",
      "fitToWindow": true,
      "gui": ["tool", "load", "help", "undo", "version", "tags", "drawList", "prompt"],
      "loaders": ["File", "Url", "GoogleDrive", "Dropbox"],
      "tools": this.tools,
      "filters": ["Threshold", "Sharpen", "Sobel"],
      "shapes": ["Arrow", "Ruler", "Protractor", "Rectangle", "Roi", "Ellipse", "FreeHand", "Rect"],
    });
    // handle load events
    let nReceivedError = null;
    let nReceivedAbort = null;
    this.dwvApp.addEventListener('load-start', (/*event*/) => {
      this.dataLoaded = false;
      nReceivedError = 0;
      nReceivedAbort = 0;
    });
    this.dwvApp.addEventListener('load-progress', (event) => {
      this.loadProgress = event.loaded;
    });
    this.dwvApp.addEventListener('load', (/*event*/) => {
      
      // set the selected tool
      let selectedTool = 'Scroll';
      if (this.dwvApp.isMonoSliceData() &&
        this.dwvApp.getImage().getNumberOfFrames() === 1) {
        selectedTool = 'ZoomAndPan';
        this.scrollIcon = false;
      }
      this.dataRange = this.dwvApp.getImage().getDataRange();
      this.options.floor = this.dataRange.min;
      this.options.ceil = this.dataRange.max;
      this.highValue = this.dataRange.max;

      this.onChangeToolWithname(selectedTool);

      // set data loaded flag
      this.dataLoaded = true;
    });
    this.dwvApp.addEventListener('load-end', (/*event*/) => {
      if (nReceivedError) {
        this.loadProgress = 0;
        alert('Received errors during load. Check log for details.');
      }
      if (nReceivedAbort) {
        this.loadProgress = 0;
        alert('Load was aborted.');
      }

      if (this.curSingleDet.saveData != null) {
        state.apply(this.dwvApp, JSON.parse(this.curSingleDet.saveData));
      }

    });
    this.dwvApp.addEventListener('error', (event) => {
      ++nReceivedError;
    });
    this.dwvApp.addEventListener('abort', (/*event*/) => {
      ++nReceivedAbort;
    });

    // handle key events
    this.dwvApp.addEventListener('keydown', (event) => {
      this.dwvApp.defaultOnKeydown(event);
    });
    this.dwvApp.addEventListener('dblclick', (event) => {

      this.dwvApp.defaultOnKeydown(event);
    });
    // handle window resize
    window.addEventListener('resize', this.dwvApp.onResize);

    dwv.utils.loadFromUri(window.location.href, this.dwvApp);

  }
  ngOnInit(): void {
    this.period = 'Today';
  }


  loadPhy(): void {
    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phyList = data.value;

      this.loadPhyList = this.phyList.slice(0);
    }, (error) => {
    }, () => {
    });
  }

  getPhysicianName(id: any): string {
    if (id != null && id != undefined && id != '' && this.loadPhyList != null && this.loadPhyList != undefined) {
      let PhysicanName = "";
      this.loadPhyList.forEach(request => { if (request.id == id) { PhysicanName = request?.name } });
      return PhysicanName;
    }
  }

  duplicateNotes(data) {
    this.duplicateNotesValues.push(data);
  }

  download(x: RadiologyEhr): void {
    x.isCreate = true;
    x.isEdit = true;
    x.isView = true;
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.downloadFileRes(data, x.fileName);
    }, (error) => {

    }, () => {

    });
  }

  downloadFileRes(data: any, filename: string) {

    var binary_string = window.atob(data);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = bytes.buffer;

    if (filename.indexOf(".pdf") > -1) {
      var blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
    else {
      var blob = new Blob([byteArray]);
      FileSaver.saveAs(blob, filename, true);
    }
  }
  Delete(x: RadiologyEhr) {
    this.deleteaddedRadiology = true;
    this.deleteId = x.id;
  }
  onDelete() {
    this.radiologySrvc.delete(`${environment.apiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${this.deleteId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

    }, (error) => {

    }, () => {

      this.loadFileData();
      this.deleteId = null;
      this.deleteaddedRadiology = false;

    });

  }

  loadFileData(): void {
    //https://ez-hms-dev-app-ser.azurewebsites.net/api/AtchDet/6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4/4e54f59e-226b-42a3-8ef2-cda3ac8fc727/getRadDet/9043710701/Hari 
    if(this.patientPortalFlag ){
      const phone = localStorage.getItem('patientMobNo');
      const name = localStorage.getItem('patientName').trim();
      this.link = `${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}}/getRadDet/${phone}/${name}`
    }else{
      this.link = `${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${this.regId}`
    }
    if(!!this.link){
    this.radiologySrvc.getById(this.link).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.filesDet = data.filter(d => d.category == "Radiology");
      this.fullData.length = 0;
      this.filesDet.forEach(element => {
        this.fullData.push({
          doneDate: element?.doneDate,
          referredBy: element?.referredBy,
          phyName: this.getPhysicianName(element?.referredBy),
          notes: element?.notes === "null" ? '' : (element?.notes || ''),
          billId: element?.billId,
          branchId: element?.branchId,
          category: element?.category,
          containerName: element?.containerName,
          doneBy: element?.doneBy,
          fileAddedBy: element?.fileAddedBy,
          fileAddedfrom: element?.fileAddedfrom || "",
          fileLocation: element?.fileLocation,
          fileName: element?.fileName,
          gA_WeekWithDays: element?.gA_WeekWithDays,
          id: element?.id,
          isPregancyPatient: element?.isPregancyPatient,
          metatags: element?.metatags,
          modality: element?.modality,
          patientRegistrationMst: element?.patientRegistrationMst,
          regId: element?.regId,
          saveData: element?.saveData,
          tagType: element?.tagType,
          tenantId: element?.tenantId,
          workOrderId: element?.workOrderId,
          workOrderDetId: element?.workOrderDetId,
          serviceName: element?.labWorkOrderDets?.service?.subCategory?.name,
          tenant: element?.tenant,
          tenantBranch: element?.tenantBranch,
          techNotes: element?.labWorkOrderDets?.techNotes,
          apprNotes: element?.labWorkOrderDets?.apprNotes,
          status:element?.patientRegistrationMst?.status
        })
        this.period= "Today"
        this.selectedArr=[]
        this.onSearch();
      });
    }, (error) => {

    }, () => {
    });}
  }
  /**
     * Get the tool names as a string array.
     */
  get toolNames(): string[] {
    return Object.keys(this.tools);
  }

  compare(): void {
    this.isCompareView = true;
    this.compareInst.loadImgs();
  }

  closeCompare(): void {
    this.isCompareView = false;
  }

  onCheckboxChge(args: { args: any, data: any }): void {

    if (args.args.target.checked == true) {
      if (this.selectedArr == null || this.selectedArr == undefined || this.selectedArr.length < 2)
        this.selectedArr.push(args.data);
      else {
        args.args.target.checked = false;
        return;
      }
    }
    else {
      if (this.selectedArr == null || this.selectedArr == undefined || this.selectedArr.length > 0) {
        let index = this.selectedArr.findIndex(i => i.id == args.data.id);
        this.selectedArr.splice(index, 1);
      }
      else{
        return;}
    }
  }

  /**
   * Handle a change tool event.
   * @param tool The new tool name.
   */
  onChangeTool = (tool: NgxSelectOption[]) => {


    if (this.dwvApp && tool != null && tool.length > 0) {
      this.selectedTool = tool[0].value as string;
      this.dwvApp.setTool(this.selectedTool);
      if (this.selectedTool === 'Draw') {
        this.onChangeShape(this.drawTool);
      }
      if (this.selectedTool === 'Filter') {
        if (this.dwvApp && this.selectedTool === 'Filter') {
          this.dwvApp.getToolboxController().setSelectedFilter(this.filterTool);
        }
      }
    }
  }

  onChangeToolWithname = (tool: string) => {
    if (this.dwvApp && tool != null && tool.length > 0) {
      this.selectedTool = tool;
      this.dwvApp.setTool(this.selectedTool);
      if (this.selectedTool === 'Draw') {
        this.onChangeShape(this.drawTool);
      }
      if (this.selectedTool === 'Filter') {
        if (this.dwvApp && this.selectedTool === 'Filter') {
          this.dwvApp.getToolboxController().setSelectedFilter(this.filterTool);

        }
      }
    }
  }

  onChangeFilter = (tool: string) => {

    this.selectedTool = 'Filter';
    this.dwvApp.setTool(this.selectedTool);
    if (this.dwvApp && tool != null && tool.length > 0) {

      if (this.selectedTool === 'Filter') {
        if (this.dwvApp && this.selectedTool === 'Filter') {
          this.filterTool = tool;
          this.dwvApp.getToolboxController().setSelectedFilter(this.filterTool);

        }
      }
    }
  }

  onFilter(): void {
    if (this.dwvApp && this.selectedTool === 'Filter') {

      this.dwvApp.setImageFilter(this.filterTool);
      this.dwvApp.runImageFilter();
      this.dataRange = this.dwvApp.getImage().getDataRange();
    }
  }

  onSliderChge(args: ChangeContext): void {
    this.dwvApp.setFilterMinMax({ "min": args.value, "max": args.highValue });
  }
  show(args: any): void {
    this.notesView = true;
  }
  hide(args: any): void {
    this.notesView = false;
  }
  onViewDetails(det: RadiologyEhr): void {
    this.editInfo = det;
    this.notes = (det.notes == "null" || null || undefined ? "" : det.notes);
    this.phy = det.referredBy;
    this.info = true;
  }

  onEditDetails(det: RadiologyEhr, flag: boolean): void {
    this.editInfo = det;
    this.infoForm.controls["info"].setValue(det.notes || "");
    this.infoForm.controls["physician"].setValue(det.referredBy);
    this.isMetaTags = false;
    this.isEdit = true;
    this.isImg = false;
    if (flag) {
      this.saveDataFlag = true;
    }
  }

  onGetImg(): void {
    this.isMetaTags = false;
    this.isEdit = false;
    this.isImg = true;
    this.infoForm.reset();
  }

  onGetTags(): void {
    this.isMetaTags = true;
    this.isEdit = false;
    this.isImg = false;
  }

  editSave(): void {
    if (this.saveDataFlag) {
      this.save();
    }
    else {
      let postData: RadiologyEhr = Object.assign({}, this.editInfo);
      postData.notes = this.infoForm.get("info").value || "";
      postData.referredBy = this.infoForm.get("physician").value;
      this.radiologySrvc.update(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${this.editInfo.id}`, postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        var targetIndex = this.filesDet.findIndex(x => x.id == data.id);
        Object.assign(this.filesDet[targetIndex], data);
        this.curSingleDet = data;
      }, (error) => {

      }, () => {
        this.onGetImg();
        this.loadFileData();
      });
    }
  }

  infoSave(): void {
    let postData: RadiologyEhr = Object.assign({}, this.editInfo);
    postData.notes = this.notes;
    postData.referredBy = this.phy;
    this.radiologySrvc.update(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${this.editInfo.id}`, postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var targetIndex = this.filesDet.findIndex(x => x.id == data.id);
      Object.assign(this.filesDet[targetIndex], data);
      this.curSingleDet = data;
    }, (error) => {

    }, () => {
      this.info = false;
      this.loadFileData();
    });
  }

  save(): void {
    this.btnDisable = true;
    let postData: RadiologyEhr = Object.assign({}, this.curSingleDet);
    postData.saveData = this.dwvApp.getState();
    postData.doneDate = this.dateService.currentDate();
    postData.fileAddedBy = this.userName;
    postData.notes = this.infoForm.get("info").value;
    postData.referredBy = this.infoForm.get("physician").value;
    postData.fileName = this.infoForm.get("fileName").value + ".dcm";
    delete postData["id"];
    delete postData["patientRegistrationMst"];
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}`, postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.loadFileData();
    }, (error) => {
      this.btnDisable = false;
    }, () => {
      this.btnDisable = false;
      this.saveDataFlag = false;
      this.onGetImg();
    });
  }

  dateWithOffset(date: Date): Date | null {
    if (date !== null && date !== undefined) {
      let returndate: Date = new Date(this.datePipe.transform(date, 'mediumDate'));
      returndate.setMinutes(date.getMinutes() + Math.abs(date.getTimezoneOffset()));
      return returndate;
    }
    else {
      return null;
    }
  }

  infoCancel(): void {
    this.info = false;
    this.infoForm.reset();
  }

  onView(det: RadiologyEhr, isView): void {
    this.viewData = det;
    if (det.fileName.indexOf(".dcm") > -1) {

      this.isSingleView = isView;
      this.curSingleDet = det;
      var requestHeaders = [{
        name: "access-control-allow-origin",
        value: "*"
      },
      {
        name: "access-control-allow-methods",
        value: "GET, PUT, POST, DELETE, HEAD, OPTIONS, PATCH"
      },
      {
        name: "content-type",
        value: "application/octet-stream"
      }
      ];
      det.isCreate = true;
      det.isEdit = true;
      det.isView = true;
      this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, det).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        var imgdata = this.base64ToArrayBuffer(data);

        this.dwvApp.loadImageObject([

          { name: det.fileName, filename: det.fileName, data: imgdata }

        ])
        this.imgname = 'data:image/jpeg;base64,' + data;
        this.radiologyPrint = (isView == false ? true : false);
      }, (error) => {

      }, () => {

      });
    }
    else if ((det.fileName as string).indexOf(".jpg") > -1 || (det.fileName as string).indexOf(".png") > -1 || (det.fileName as string).indexOf(".jpeg")) {
      det.isCreate = true;
      det.isEdit = true;
      det.isView = true;
      this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, det).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.imgname = 'data:image/jpeg;base64,' + data;

        this.imgView = isView;
        this.radiologyPrint = (isView == false ? true : false);
      }, (error) => {

      }, () => {
      });
    }

  }

  private base64ToArrayBuffer(base64) {
    var binaryString = atob(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  imgCancel(): void {
    this.imgView = false;
  }

  onCloseSingle(): void {
    this.isSingleView = false;
  }



  onZoom(): void {
    this.dwvApp.zoom()
  }
  onUndo(): void {
    this.dwvApp.undo()
  }
  onRedo(): void {
    this.dwvApp.redo()
  }

  /**
   * Handle a change draw shape event.
   * @param shape The new shape name.
   */
  public onChangeShape = (shape: string) => {
    this.selectedTool = 'Draw';
    this.dwvApp.setTool(this.selectedTool);
    if (this.dwvApp && this.selectedTool === 'Draw') {
      this.drawTool = shape;
      this.dwvApp.setDrawShape(shape);
    }
  }

  onReset = () => {
    if (this.dwvApp) {
      var drawList = this.dwvApp.getDrawDisplayDetails();
      drawList.forEach(element => {
        this.dwvApp.deleteDraws(element);
      });
      this.dwvApp.resetDisplay();
    }
  }
  onResetFilter() {
    this.term = "";
    this.period = 'Today';
    this.rangeDate = null;
    this.selectedArr = [];
    this.loadFileData();

  }

  periodChange(event) {
    if (event.length > 0 && event != undefined) {
      this.betweenFlag = false;
      if (event[0]?.value == "Between") {
        this.betweenFlag = true;
      }
    }
    if (event.length == 0) {
      this.betweenFlag = false;
    }
  }

  onSearch() {
    let fDate, tDate
    var date = this.dateService.currentDate();
    if (this.period != "" && this.period != "Between") {
      switch (this.period) {
        case 'Today':
          fDate = date;
          tDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          fDate = date;
          tDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          fDate = new Date(today.setDate(today.getDate() - today.getDay()));
          tDate = date;
          break;
        case 'This Month':
          fDate = new Date(date.getFullYear(), date.getMonth(), 1);
          tDate = date;
          break;
        case 'This Year':
          fDate = new Date(date.getFullYear(), 0, 1);
          tDate = date;
          break;
      }
    }
    else {
      if (this.rangeDate !== null && this.rangeDate !== undefined) {
        if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
          this.rangeDate[1] = this.rangeDate[0];
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
          this.rangeDate[0] = this.rangeDate[1];
        }
        fDate = this.rangeDate[0];
        tDate = this.rangeDate[1];
      }
      
    }

    if (this.term == "" || this.term == undefined)
      this.term = null;
    let searchData = {
      searchWord: this.term,
      fromDate: this.dateService.utcFromDate(fDate),
      toDate: this.dateService.utcToDate(tDate),
    }
    this.dataSourceRadiologyGrid = this.fullData?.filter(x =>
      (searchData.fromDate <= x.doneDate && x.doneDate <= searchData.toDate))
  }

  getJson(data: any): JSON {
    return JSON.parse(data);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }

  get getApiUrl(): string {
    return environment.apiUrl;
  }

  radiologyprevclicked() {
    if (this.p > 1)
      this.p = this.p - 1
  }
  radiologynextclicked() {
    if (this.p < (this.dataSourceRadiologyGrid.length / 10)) {
      this.p = this.p + 1
    }
  }

  patientPortal(){
    this.patientPortalFlag=true;
    this. StartPatientData();
  }

}
